import moneyFormat from "../../../utilities/moneyFormat.js";
import dollarsToCents from "dollars-to-cents";
import MultiMap from "../../../utilities/MultiMap.js";
import AmountSearchAdapter from "./AmountSearchAdapter.js";

export default class BaseSearchAdapter {
	listUpdatePending = false;
	listRequestedCallback = () => {
		return [];
	};

	constructor(textSearcher) {
		this.textSearcher = textSearcher;
		this.amountSearcher = new AmountSearchAdapter();
	}

	async search(query) {
		const moneyFormatted = moneyFormat(query);
		if(this.listUpdatePending) {
			this.listUpdatePending = false;
			this.updateSearchList();
			this.textSearcher.setTransactions(this.latestResults);
			this.amountSearcher.setTransactions(this.latestResults);
		}
		if(moneyFormatted !== '$NaN') {
			query = dollarsToCents(query);
			return await this.amountSearcher.search(query);
		}
		return await this.textSearcher.search(query);
	}

	updateSearchList() {
		this.latestResults = this.listRequestedCallback();
	}

	listUpdated() {
		this.listUpdatePending = true;
	}

	setListRequestedCallback(callback) {
		this.listRequestedCallback = callback;
	}

}